import React from "react";
import { RocketLaunch } from "@mui/icons-material";

export const ACCELERATE_MENU = {
  ABSOLUTE_PATH: "",
  PATH: "",
  TITLE: "Accelerate",
  ICON: <RocketLaunch style={{ color: "#054254" }} />,
  renderMenu: true,
  hideInSidebarWhenDisabled: true,
};
